import { Directive, Input, HostListener } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { take } from 'rxjs/operators';

@Directive({
    selector: 'a[unhDownloadResource]',
})
export class DownloadResourceDirective {
    @Input() href: string;

    constructor(private http: HttpClient) { }

    @HostListener('click', ['$event'])
    onClick(evt) {
        evt.preventDefault();
        this.downloadResource();
    }

    private downloadResource() {
        const anchorLink = this.href;
        this.http.get(anchorLink, { responseType: 'blob' }).pipe(take(1)).subscribe(blob => {
            const url = URL.createObjectURL(blob);
            this.download(url, 'jpg');
            URL.revokeObjectURL(url);
        });
    }

    private download(url: string, filetype: string) {
        const anchorEl: HTMLAnchorElement = document.createElement('a');
        const urlParts = url.split('/');
        const filename = urlParts[urlParts.length - 1];
        anchorEl.href = url;
        anchorEl.style.display = 'none';
        anchorEl.setAttribute('download', filename + '.' + filetype);
        anchorEl.click();
    }
}
